<div class="zero-view-container">
  <mat-accordion>
    @for (item of datasource; track item; let i = $index) {
      <mat-expansion-panel data-test="zero-view-expansion-panel-headers" class="border">
        <mat-expansion-panel-header class="inner-header">
          <div class="header-icon" fxFlex="60px">
            @if (i !== 2) {
              <mat-icon>{{ item.icon }}</mat-icon>
            }
            @if (i === 2) {
              <img width="32" height="32" src="/assets/img/google_tag_manager.png" />
            }
          </div>
          <div>
            <strong>{{ item.header }}</strong>
            <br />
            <div class="small">{{ item.text }}</div>
          </div>
        </mat-expansion-panel-header>
        <div class="inner-content">
          @if (item.instructions) {
            <div [innerHTML]="item.instructions"></div>
          }
          @if (i === 0) {
            <app-tracking-code></app-tracking-code>
          }
          @if (item.buttonText) {
            <button mat-stroked-button class="primary-button download" (click)="openWordpressPlugin()">
              <mat-icon>cloud_download</mat-icon>
              {{ item.buttonText }}
            </button>
          }
          @if (i === 2) {
            <div class="google-tag-manager-description">
              <p>{{ item.mainText }}</p>
              <p>{{ item.secondaryText }}</p>
              <a href="{{ item.link }}" target="_blank">{{ item.link }}</a>
            </div>
          }
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
